<template>
  <AccessStateLayout
    description="This session has ended. You can close this tab now."
    eyebrow="Session complete"
    test-id="bye-bye-state"
    title="See You Next Time!"
  />
</template>

<script setup lang="ts">
import AccessStateLayout from './AccessStateLayout.vue';
</script>
